import ApiClient from '../../../../base/api';
import {
    GetLoginResponse,
    GetMessengersResponse,
    ChangeLoginParams,
    CreateLoginParams,
    ChangePasswordParams,
} from './interfaces';

const apiClient = new ApiClient();

export const settingsApi = {
    getLogin: () => apiClient.get<GetLoginResponse>('/api/profile/phone'),
    changeLogin: (data: ChangeLoginParams) => apiClient.post<ChangeLoginParams, void>('/api/profile/phone', data),
    createLogin: (data: CreateLoginParams) =>
        apiClient.post<CreateLoginParams, void>('/api/profile/create-login', data),
    changePassword: (data: ChangePasswordParams) =>
        apiClient.post<ChangePasswordParams, void>('/api/profile/password', data),
    getMessengers: () => apiClient.get<GetMessengersResponse>('/api/profile/messengers'),
    removeMessenger: (messengerId: number) => apiClient.delete(`/api/profile/messengers/${messengerId}`),
};
